
<div class="dropdown notification-dropdown unread-notification-bell">
  <button id="notificationDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="d-flex">
    <span class="icon-and-count">
      <span class="icon" :class="[notifications.length > 0 ? 'notification-on' : 'notification-off']"></span>
      <span v-if="!hasNoNotifications" class="notification-count">{{ unreadCount }}</span>
      <span class="sr-only">Notification Bell Button</span>
    </span>
  </button>
  <div class="dropdown-menu dropdown-menu-right pb-0" aria-labelledby="notificationDropdown" style="left: auto;">
    <a
      v-for="notification in firstTenNotifications"
      :key="notification.id"
      class="dropdown-item py-3 px-4"
      @click="markNotificationAsRead(notification)"
      :href="notificationLink(notification)">
      <div class="row">
        <icon :glyph="glyphFor(notification)" class="col-2 pr-0"></icon>
        <h2 class="col-10 pl-0 label-sm">{{notification.title}}</h2>
      </div>
      <div class="date row justify-content-end">
        <div class="col-10 pl-0">
          <span v-if="shouldShowAuthor">
            {{formattedAuthor(notification)}}
          </span>
          <relative-date-time :timezone="timezone" :created_at="notification.c_at"></relative-date-time>
        </div>
      </div>

      <div class="row justify-content-end">
        <p v-html="formattedMessage(notification.message)" class="notification-message col-10 pl-0"></p>
      </div>
    </a>
    <p v-if="hasNoNotifications" class="dropdown-item py-3">You have no new notifications</p>
    <a v-if="hasOverTenNotifications" class="dropdown-item py-3" href="/notifications">
      View all {{ unreadCount }} unread notifications in feed
    </a>
    <div class="cta">
      <a class="btn xs blue outline" href="/notifications">Go to my feed</a>
      <button type="button" class="btn-link blue" @click="fetchNotifications">Refresh</button>
    </div>
  </div>
</div>
